import { useIntl } from 'react-intl';
import styles from './StatusBadge.module.scss';
import { ReportStatus } from '../../types';
import clsx from 'clsx';

interface StatusBadgeProps {
  status: ReportStatus;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className }) => {
  const intl = useIntl();
  var styleStatus = status.replace(/\s+/g, '');
  return (
    <span className={clsx(styles.statusBadge, styles[`statusBadge${styleStatus}`], className)}>{status.toLowerCase()}</span>
  );
};
